const convertDecimalToAmerican = (odds: number | string) => {
  if (typeof odds === "number") {
    if (odds < 2) {
      return -100 / odds;
    }
    return `+${odds * 100}`;
  }

  return odds;
};

export const handleOddsFormat = (
  format: string,
  odds: string,
  decimalOdds: number,
  fractionalOdds: string
) => {
  switch (format) {
    case "american": {
      if (odds) {
        return odds;
      }
      return convertDecimalToAmerican(decimalOdds);
    }

    case "decimal":
      return numberToDecimalFloor(decimalOdds);

    case "fractional":
      if (fractionalOdds) {
        return fractionalOdds;
      }

      // if no fractional odds are returned from the api then we should fallback to american odds
      return odds;

    default:
      return null;
  }
};

export const convertFractionToDecimal = (fraction: string) => {
  if (typeof fraction === "string") {
    const split = fraction.split("/");
    const result = parseInt(split[0], 10) / parseInt(split[1], 10);

    return result;
  }
  return 0;
};

export const convertFractionToAmerican = (fraction: string) => {
  if (typeof fraction === "string" && fraction !== "") {
    const split = fraction.split("/");
    const decimalOdds = parseInt(split[0], 10) / parseInt(split[1], 10);

    if (decimalOdds < 1) {
      return -100 / decimalOdds;
    }

    return `+${decimalOdds * 100}`;
  }
  return 0;
};

export const numberToDecimalFloor = (
  num: number,
  decimalPlaces: number = 2
): string => {
  const multiplier = 10 ** decimalPlaces;
  return (Math.floor(num * multiplier) / multiplier).toFixed(decimalPlaces);
};
